import type { PaymentOption } from '@src/domains/payments/types/payment';

export const isMissingExecutionRule = (paymentOption: PaymentOption): boolean =>
  Boolean(paymentOption.requiresExternalAuthentication) && !paymentOption.paymentAuthSettings?.executionRule;
